import NewResearchQueryBuilder from "models/research/newResearchQueryBuilder";
import { BASE_PATH } from "../../components/apiConstants";

export default class ArticleCountQueryBuilder extends NewResearchQueryBuilder {
   baseUrl = `${BASE_PATH}/research/count`;
}